import React from 'react';
import _ from 'lodash';
import { useQuery } from 'react-fetching-library';
import { Box } from '@mui/material';

import { getBonusesAction } from '../../../services/request';
import { BonusList } from './bonus/BonusList';
import { CircularProgressContainer } from '../../../components/others/CircularProgressContainer';
import { AlertDialogContainer } from '../../../components/others/AlertDialogContainer';

export const BonusRecord = () => {
  const [search, setSearch] = React.useState(null);
  // const { loading, payload, error } = useQuery(getBonusesAction(search, 'GET'));
  const { loading, payload, error } = useQuery(getBonusesAction(search, 'GET'));

  // const optionsRequest = useQuery(getBonusesAction(null, 'OPTIONS'));
  const [openSidebar, setOpenSidebar] = React.useState(false);
  const [hideSidebar, setHideSidebar] = React.useState(false);
  const [bonuses, setBonuses] = React.useState([]);
  const [showAlert, setShowAlert] = React.useState(false);
  const [severity, setSeverity] = React.useState('');
  const [title, setTitle] = React.useState('');
  const [message, setMessage] = React.useState('');
  // const [allSeasons, setAllSeasons] = React.useState([]);
  // const [allResorts, setAllResorts] = React.useState([]);
  // const [allAgeRanges, setAllAgeRanges] = React.useState([]);
  // const [allCamps, setAllCamps] = React.useState([]);

  React.useEffect(() => {
    if (!loading && !error) {
      setBonuses(payload.results);
    }
  }, [loading]);


  // React.useEffect(() => {
  //   if (!optionsRequest.loading && !optionsRequest.error) {
  //     setAllSeasons(optionsRequest.payload.actions.GET.season.choices);
  //     setAllResorts(optionsRequest.payload.actions.GET.resort.choices);
  //     setAllAgeRanges(optionsRequest.payload.actions.GET.age_range.choices);
  //     setAllCamps(optionsRequest.payload.actions.GET.camp.choices);
  //   }
  // }, [optionsRequest.loading]);

  const queryCallback = (searchVal = null) => {
    setSearch(searchVal);
  };

  const submitCallback = (obj2, method, severity, title, message) => {
    if (method === 'edit') {
      setBonuses(
        _.map(bonuses, obj => obj.id === obj2.id ? obj2 : obj)
      );
    } else if (method === 'delete') {
      setBonuses(_.filter(bonuses, obj => obj.id !== obj2.id));
    } else {
      setBonuses([obj2, ...bonuses]);
    }
    setSeverity(severity);
    setTitle(title);
    setMessage(message);
    setShowAlert(true);
  };

  return (
    <>
      {loading
        ? <CircularProgressContainer size={50} thickness={2.5} />
        : null}
      {showAlert && (
        <AlertDialogContainer
          severity={severity}
          title={title}
          message={message}
          setShowAlert={setShowAlert}
        />
      )}
      <BonusList
        loading={loading}
        hideSidebar={() => setHideSidebar(!hideSidebar)}
        onOpenSidebar={() => setOpenSidebar(true)}
        bonuses={bonuses}
        queryCallback={queryCallback}
        submitCallback={submitCallback}
        // allSeasons={allSeasons}
        // allResorts={allResorts}
        // allAgeRanges={allAgeRanges}
        // allCamps={allCamps}
        setBonuses={setBonuses} />
    </>
  );
};
